import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/throttleTime';
import { sendUpdateMessage } from '../../websocket';
export function maximumSpeedChange(value) {
    return { type: 'MAXIMUM_SPEED_CHANGE', value: value };
}
export function locationChange(latitude, longitude) {
    return { type: 'LOCATION_CHANGE', latitude: latitude, longitude: longitude };
}
export var maximumSpeedEpic = function (action$) {
    return action$.ofType('MAXIMUM_SPEED_CHANGE')
        .debounceTime(500)
        .map(function (a) { return sendUpdateMessage('maximumSpeed', a.value); });
};
export var locationEpic = function (action$) {
    return action$.ofType('LOCATION_CHANGE')
        .throttleTime(300)
        .map(function (a) { return sendUpdateMessage('location', { latitude: a.latitude, longitude: a.longitude }); });
};



//////////////////
// WEBPACK FOOTER
// ./src/components/MapControl/actions.ts
// module id = 313
// module chunks = 0